/**
 * Take care of the login component.
 */
const members = {

	/**
	 * Member status constants.
	 *
	 * @type {string}
	 */
	STATUS_LOADING: 'loading',
	STATUS_LOGGEDIN: 'loggedin',
	STATUS_LOGGEDOUT: 'loggedout',


	/**
	 * The ID for the signup banner that goes showed and hidden based upon the users state.
	 *
	 * @type {string}
	 */
	SIGNUP_BANNER: 'user-signup-banner',


	/**
	 * Userbase APPID.
	 *
	 * @type {string}
	 */
	APP_ID: '4a9f69ba-2527-42cc-a577-e89253d81bc4',
	APP_ID_TEST: '98122218-b0b7-443f-8d3b-763625df5059',


	/**
	 * The url prefix for beta testing.
	 *
	 * @type {string}
	 */
	TESTURL: 'brush-ninja--beta',


	/**
	 * The CDN url for downloading animations.
	 *
	 * @type {string}
	 */
	DOWNLOW_URL: 'https://files.brush.ninja/animations',


	/**
	 * The Reef app object.
	 *
	 * @var {object}
	 */
	app: null,


	/**
	 * Initialize the component.
	 *
	 * @return {void}
	 */
	init: function() {

		console.log( 'members.init' );
		members.checkUserbase();

	},


	/**
	 * Check if userbase is loaded.
	 * If not then wait a bit and try again.
	 *
	 * @return {void}
	 */
	checkUserbase: function() {

		if ( !members.userbaseEnabled() ) {
			setTimeout( members.checkUserbase, 150 );
		} else {
			console.log( 'userbase loaded' );
			members.userbaseInit();
		}

	},


	/**
	 * Initialize userbase.
	 *
	 * @return {void}
	 */
	userbaseInit: function() {

		members.init_nav();

		let app_id = members.APP_ID;

		if ( members.isLocal() ) {
			app_id = members.APP_ID_TEST;
		}

		userbase.init( { appId: app_id } )
			.then(
				( session ) => {
					if ( session.user ) {
						members.setUserLoggedIn( session.user );
					} else {
						members.setUserLoggedOut( session.user );
					}
					document.querySelector( 'body' ).classList.remove( 'members-loading' );
				}
			);

	},


	/**
	 * Initialize the navigation.
	 *
	 * @return {void}
	 */
	init_nav: function() {

		const $navWrapper = document.querySelector( '.nav-members' );

		if ( !$navWrapper ) {
			return;
		}

		// Userbase isn't defined so must be offline.
		if ( !members.userbaseEnabled() ) {
			$navWrapper.remove();
			return;
		}

		// Create the Reef app.
		// Separate from the other apps since it works on every page.
		members.app = new Reef(
			$navWrapper,
			{
				data: {
					status: members.STATUS_LOADING,
					member: null,
				},
				template: members.template,
			}
		);

		// Init MemberStack.
		members.app.render();

		$navWrapper.addEventListener( 'click', members.handleNavClick );

	},


	/**
	 * Is the current environment localhost?
	 *
	 * @return {boolean}
	 */
	isLocal: function() {

		return window.location.href.includes( 'localhost' );

	},


	/**
	 * Handle user navigation clicks.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleNavClick: function( e ) {

		const target = e.target.getAttribute( 'href' );

		if ( !target ) {
			return;
		}

		if ( target.startsWith( '/#/ms/' ) ) {
			e.preventDefault();
			e.stopPropagation();
		}

		// Logout.
		if ( '/#/ms/logout' === target ) {

			members.setUserLoading();

			userbase.signOut()
				.then(
					( session ) => {
						members.setUserLoggedOut();
					}
				);

		}

		// Login.
		if ( '/#/ms/login' === target ) {

			loginform.display();

		}

	},


	/**
	 * User data changing so display loading bar.
	 *
	 * @return {void}
	 */
	setUserLoading: function() {

		if ( !members.app ) {
			return;
		}

		members.app.setData(
			{
				status: members.STATUS_LOADING,
				member: undefined
			}
		);

	},


	/**
	 * User logged in so update state.
	 *
	 * @param {object} user The user that has logged in.
	 * @return {void}
	 */
	setUserLoggedIn: function( user ) {

		if ( members.app ) {
			members.app.setData(
				{
					status: members.STATUS_LOGGEDIN,
					member: user
				}
			);
		}

		ninjaEvent( 'login-status-change' );

		/**
		 * If the user is not a subscriber, but IS a registered user then
		 * display the signup banner.
		 */
		if ( !members.isSubscriber() ) {

			const $signupBanner = document.getElementById( members.SIGNUP_BANNER );

			if ( $signupBanner ) {
				$signupBanner.classList.add( 'display-block' )
				$signupBanner.classList.remove( 'display-none' );
			}

		} else {

			document.querySelector( 'body' ).classList.add( 'members-subscribed' );

		}

	},


	/**
	 * User logged out so update state.
	 *
	 * @param {object} user The logged out user properties.
	 * @return {void}
	 */
	setUserLoggedOut: function( user = undefined ) {

		if ( members.app ) {
			members.app.setData(
				{
					status: members.STATUS_LOGGEDOUT,
					member: user
				}
			);
		}

		ninjaEvent( 'login-status-change' );

		/**
		 * Hide the signup banner.
		 */
		const $signupBanner = document.getElementById( members.SIGNUP_BANNER );
		if ( $signupBanner ) {
			$signupBanner.classList.add( 'display-none' );
			$signupBanner.classList.remove( 'display-block' );
		}

		document.querySelector( 'body' ).classList.remove( 'members-subscribed' );

	},


	/**
	 * Set user navigation to the last known state based on whether the user is
	 * logged in or not.
	 *
	 * @return {void}
	 */
	resetUserLogStatus: function() {

		if ( !members.app ) {
			return;
		}

		const user = members.app.data.member;

		if ( user ) {
			members.setUserLoggedIn( user );
		} else {
			members.setUserLoggedOut( user );
		}

	},


	/**
	 * The template for the component.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	template: function( props ) {

		// Shared link CSS class.
		const linkClass = 'flex-g1 p2 p-x3 b-br2 bg-blue';

		let html = '';

		switch ( props.status ) {

			case members.STATUS_LOADING:

				html += `<div class="loading__small w4"></div>`;

				break;

			case members.STATUS_LOGGEDIN:

				console.log( members.app.data.member );
				// ${props.member.username}

				html += `
				<a class="${linkClass}" href="/members/profile/?tok=${props.member.username}" title="Edit Profile">Profile</a>
				<a class="${linkClass} flex flex-ai-c" href="/#/ms/logout" title="Logout">
					<span class="screen-reader-text">Logout</span>
					<img src="/assets/images/button-logout.svg" class="pe-none" alt="*" />
				</a>
				`;

				break;

			case members.STATUS_LOGGEDOUT:
			default:

				html += `
				<a class="${linkClass} flex gap1" href="/join/"><span class="icon-premium"></span> Join</a>
				<a class="${linkClass}" href="/#/ms/login">Login</a>
				`;

				break;

		}

		return html;

	},


	/**
	 * Is the current user a logged in member or not?
	 *
	 * @return {boolean}
	 */
	loggedIn: function() {

		// Userbase isn't defined so must be offline.
		if ( !members.userbaseEnabled() ) {
			return false;
		}

		// Display premium features on firebase test url.
		if ( window.location.href.includes( members.TESTURL ) ) {
			console.log( 'login fb test' );
			return true;
		}

		if ( !members.app ) {
			return false;
		}

		// Get user data.
		const member = members.app.data.member;

		if ( !member ) {
			return false;
		}

		// Allow the binarymoon account to test paid memberships.
		const testname = "bi" + 'na' + 'rymo' + `on`;
		if ( testname === member[ `us${'er' + 'na'}` + `me` ] ) {
			console.log( 'admin user logged in' );
			return true;
		}

		// If the member is active then they have a valid subscription.
		if ( 'active' === member.subscriptionStatus ) {
			console.log( 'user logged in' );
			return true;
		}

		return false;

	},


	/**
	 * Is the user a paid subscriber?
	 *
	 * @return {boolean}
	 */
	isSubscriber: function() {

		return members.loggedIn();

	},


	/**
	 * Is the user a premium member?
	 * Just a wrapper for isSubscriber (and convenience).
	 *
	 * @return {boolean}
	 */
	isPremium: function() {

		return members.loggdIn();

	},


	/**
	 * Is userbase enabled.
	 * Will be false if the user is offline.
	 *
	 * @return {boolean}
	 */
	userbaseEnabled: function() {

		const defined = 'undefined' === typeof userbase;
		return !defined;

	},


	/**
	 * Get the user data for the logged in user.
	 *
	 * @return {object} The logged in users info.
	 */
	memberData: function() {

		return members.app.data;

	},


	/**
	 * Initialize CDN downloads.
	 *
	 * @param {string} selector The DOM string that will select the links that need updating.
	 * @return {null}
	 */
	init_downlow: function( selector = null ) {

		if ( !selector ) {
			return;
		}

		const links = document.querySelectorAll( selector );

		if ( links.length < 1 ) {
			return;
		}

		links.forEach(
			element => {

				element.addEventListener(
					'click',
					( e ) => {
						members.downlow( e );
					}
				);

			}
		);

	},


	/**
	 * Download a file from S3, checking the user is logged in before we do so.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	downlow: function( e ) {

		// Don't let free users download the animations.
		if ( !members.isSubscriber() ) {
			alert( 'Files are for subscribed users. Subscribe to get access to the image downloads.' );
			return;
		}

		if ( !e ) {
			return;
		}

		const target = e.target;
		const download_id = target.getAttribute( 'data-dl' );
		// console.log( download_id );

		if ( !download_id ) {
			return;
		}

		const filename = download_id + '.brushninja';
		const url = members.DOWNLOW_URL + '/' + filename;

		// console.log( filename );

		downloadLink( filename, url );

	},


	/**
	 * Display a userbase error message in the specified div.
	 *
	 * @param {object} message The error object.
	 * @param {string} id The id of the div to place the error in. Does not need the #.
	 * @return {void}
	 */
	errorDisplay: function( message, id ) {

		/**
		 * Convert the object that only holds a string, into a string that can
		 * be edited.
		 */
		message = message + '';
		// Grab the error element.
		const error_message = document.getElementById( id );
		if ( !error_message ) {
			return;
		}
		// Display the error element.
		error_message.classList.remove( 'display-none' );
		// Display the error, splitting the error code off of the front.
		let message_parts = message.split( ':' );
		if ( message_parts[ 1 ] ) {
			message = message_parts[ 1 ];
		}
		error_message.innerHTML = message;

	},


	/**
	 * Disable a button temporarily.
	 *
	 * @param {object} target The button to disable.
	 * @return {void}
	 */
	disableButton: function( target ) {

		const currentHtml = target.getAttribute( 'value' );
		// Disable button.
		target.setAttribute( 'disabled', 'disabled' );
		target.setAttribute( 'value', 'Processing...' );

		setTimeout(
			() => {
				target.removeAttribute( 'disabled' );
				target.setAttribute( 'value', currentHtml );
			},
			5000
		);

	}

};


